export const FETCH_CERTS = 'FETCH_CERTS' as const;
export const FETCH_CERTS_SUCCESS = 'FETCH_CERTS_SUCCESS' as const;
export const FETCH_CERTS_FAIL = 'FETCH_CERTS_FAIL' as const;
export const FETCH_CERTS_CANCEL = 'FETCH_CERTS_CANCEL' as const;

export const FETCH_CERT = 'FETCH_CERT' as const;
export const FETCH_CERT_SUCCESS = 'FETCH_CERT_SUCCESS' as const;
export const FETCH_CERT_FAIL = 'FETCH_CERT_FAIL' as const;
export const FETCH_CERT_CANCEL = 'FETCH_CERT_CANCEL' as const;

export const SAVE_CERT = 'SAVE_CERT' as const;
export const SAVE_CERT_SUCCESS = 'SAVE_CERT_SUCCESS' as const;
export const SAVE_CERT_FAIL = 'SAVE_CERT_FAIL' as const;
export const SAVE_CERT_CANCEL = 'SAVE_CERT_CANCEL' as const;

export const VALIDATE_CERT = 'VALIDATE_CERT' as const;
export const VALIDATE_CERT_SUCCESS = 'VALIDATE_CERT_SUCCESS' as const;
export const VALIDATE_CERT_FAIL = 'VALIDATE_CERT_FAIL' as const;
export const VALIDATE_CERT_CANCEL = 'VALIDATE_CERT_CANCEL' as const;

export const DELETE_CERT = 'DELETE_CERT' as const;
export const DELETE_CERT_SUCCESS = 'DELETE_CERT_SUCCESS' as const;
export const DELETE_CERT_FAIL = 'DELETE_CERT_FAIL' as const;
export const DELETE_CERT_CANCEL = 'DELETE_CERT_CANCEL' as const;
